import {Controller} from "@hotwired/stimulus";
import {waitForOutletToBeLoaded} from "../../js/functions";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        litigantId: Number,
        litigantName: String,
        source: String,
        flowFromEmail: Boolean,
    };

    static outlets = [
        'payment--direct-payment-modal',
    ];

    async paymentDirectPaymentModalOutletConnected() {
        if (this.flowFromEmailValue) {
            dataLayer.push({
                "event": "dataLayer.gaEvent",
                "gaEvent": {
                    "category": "Flow",
                    "action": "Flow from email",
                    "label": "direct payment",
                },
            });

            await waitForOutletToBeLoaded(() => this.paymentDirectPaymentModalOutlet);

            this.openModal();
        }
    }

    openModal() {
        $('#payment-unavailable-modal').modal('show');
    }
}
